var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoSuporteBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Suporte") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-216.000000, -538.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Suporte",
    transform: "translate(217.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.17751899,14.3547089 C4.17751899,15.1944557 3.49675949,15.874962 2.65726582,15.874962 L1.5203038,15.874962 C0.680556962,15.874962 5.06329114e-05,15.1944557 5.06329114e-05,14.3547089 L5.06329114e-05,9.35091139 C5.06329114e-05,8.51141772 0.680556962,7.83065823 1.5203038,7.83065823 L2.65726582,7.83065823 C3.49675949,7.83065823 4.17751899,8.51141772 4.17751899,9.35091139 L4.17751899,14.3547089 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8470127,14.3547089 C19.8470127,15.1944557 19.1662532,15.874962 18.3267595,15.874962 L17.1897975,15.874962 C16.3500506,15.874962 15.6695443,15.1944557 15.6695443,14.3547089 L15.6695443,9.35091139 C15.6695443,8.51141772 16.3500506,7.83065823 17.1897975,7.83065823 L18.3267595,7.83065823 C19.1662532,7.83065823 19.8470127,8.51141772 19.8470127,9.35091139 L19.8470127,14.3547089 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50875949,15.8750127 C2.50875949,17.4603291 3.79382278,18.7456456 5.37939241,18.7456456 L8.43610127,18.7456456",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50875949,7.41475949 C2.50875949,3.31982278 5.82850633,7.59493671e-05 9.92344304,7.59493671e-05 C14.0186329,7.59493671e-05 17.3383797,3.31982278 17.3383797,7.41475949",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4108354,18.3596709 C11.4108354,19.1811899 10.7450127,19.8470127 9.92349367,19.8470127 C9.10197468,19.8470127 8.4361519,19.1811899 8.4361519,18.3596709 C8.4361519,17.5381519 9.10197468,16.8723291 9.92349367,16.8723291 C10.7450127,16.8723291 11.4108354,17.5381519 11.4108354,18.3596709 Z",
    id: "Stroke-9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSuporteBlue);
export default __webpack_public_path__ + "static/media/PictoSuporteBlue.f5c8b32ec3e71e002926ff4bbe611db9.svg";
export { ForwardRef as ReactComponent };